import {
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    InputLabel,
    LinearProgress,
    MenuItem,
    Paper,
    Typography,
  } from "@material-ui/core";
  import {
    useAddProcedureDefinitionsToTestSequence,
    useAddReportDefinitionsToTestSequence,
    useCreateReportSequence,
    useCreateTestSequence,
  } from "../../projectManagementMutations";
  import { Field, Form, Formik } from "formik";
  import * as Yup from "yup";
  import { toast } from "react-toastify";
  import { Select, TextField } from "formik-material-ui";
  import React from "react";
  import { useHistory, useParams } from "react-router-dom";
  import { useTestSequenceDefinitionsDispositions } from "../../../common/services/dispositionServices";
  import {
    useGroupsByGroupType,
    useUnitTypeFamilies,
  } from "../../projectManagementQueries";
  import { useTestSequenceDefinition } from "../../testSequenceDefinitionQueries";
  import { ErrorMessage } from "../../../common/ErrorMessage";
  import {
    useRemoveProcedureDefinitionsFromTestSequence,
    useUpdateTestSequence,
  } from "../../projectManagementMutations";
  import { LSDBModal, useLSDBModalState } from "../../../common/LSDBModal";
  import { WorkOrderTestSequenceTraveler } from "../customerDetails/workOrders/WorkOrderTestSequenceTraveler";
  import ReceiptIcon from "@material-ui/icons/Receipt";

  import LSDBColorPicker from "../../../common/LSDBColorPicker";

import RSDForm from "./RSDForm";
import ReportDefinitionsPicker from "./ReportDefinitions/ReportDefinitionsPicker";
import { ReportExecutionOrder } from "../../types/ReportExecutionOrder";
import { addProcedureDefinitionToList, removeProcedureDefinitionFromList } from "./ReportDefinitions/helpers";
import { useReportSequenceDefinition } from "../../reportSequenceDefinitionQueries";
  
  const RSDTemplate = ({ tsdId }: any)  => {
    const history = useHistory();  
    const {
      openModal: isOpenModal,
      setOpenModal,
      handleModalAction,
    } = useLSDBModalState();
    const [selectedProcedureDefinitions, setSelectedProcedureDefinitions] =
    React.useState<ReportExecutionOrder[]>([]);
    const [tsdHexColor, setTsdHexColor] = React.useState("#000000");
    const { mutateAsync: createTestSequence } = useCreateReportSequence();
    const { mutateAsync: addProcedureDefinitionsToTestSequence } = useAddReportDefinitionsToTestSequence();

      const addProcedureDefinitionToSelectedList = (
        procedureDefinition: ReportExecutionOrder
      ) => {
        setSelectedProcedureDefinitions((prevState) =>
          addProcedureDefinitionToList(prevState, procedureDefinition)
        );
      };

      const removeProcedureDefinitionFromSelectedList = (
        procedureDefinition: ReportExecutionOrder
      ) => {
        setSelectedProcedureDefinitions((prevState) =>
          removeProcedureDefinitionFromList(prevState, procedureDefinition)
        );
      };

      const editProcedureDefinitionInSelectedList = (
        procedureDefinitionToEdit: ReportExecutionOrder,
        newProcedureDefinition: ReportExecutionOrder
      ) => {
        setSelectedProcedureDefinitions((prevState) =>
          addProcedureDefinitionToList(
            removeProcedureDefinitionFromList(prevState, procedureDefinitionToEdit),
            newProcedureDefinition
          )
        );
      };
    
  
    const {
      data: testSequence,
      error: testSequenceError,
      isError: isErrorTestSequence,
      isLoading: isLoadingTestSequence,
    } = useReportSequenceDefinition(tsdId);
  
    // React.useEffect(() => {
    //   if (
    //     testSequence &&
    //     testSequence.procedure_definitions &&
    //     testSequence.procedure_definitions.length !== 0
    //   ) {
    //     const procedureDefinitions: ReportExecutionOrder[] =
    //       testSequence.procedure_definitions.map((procedureDefinition: any) => {
    //         const reportExecutionOrder: ReportExecutionOrder = {
    //           execution_group_name: procedureDefinition.execution_group_name,
    //           report_definition_id: procedureDefinition.report_definition_id,
    //           execution_group_number: procedureDefinition.execution_group_number,
    //           product_definition_id:  procedureDefinition.product_definition_id,
    //           report_sequence_definition_id: procedureDefinition.report_sequence_definition_id,
    //           procedure_definition_name:procedureDefinition.procedure_definition_name,
    //         };
  
    //         return reportExecutionOrder;
    //       });
  
    //     setTsdHexColor(testSequence.hex_color);
    //     setSelectedProcedureDefinitions(procedureDefinitions);
    //   }
    // }, [testSequence]);
    // React.useEffect(() => {
    //     if (testSequence && typeof testSequence === "object"&& Object.keys(testSequence).length > 0) {
    //       const reportExecutionOrder: ReportExecutionOrder = {
    //         execution_group_name: testSequence.execution_group_name ,
    //         report_definition_id: testSequence.report_definition_name  ,
    //         execution_group_number: testSequence.execution_group_number ,
    //         product_definition_id: testSequence.product_definition_name ,
    //         // report_sequence_definition_id: testSequence.report_sequence_definition_id ,
    //         // procedure_definition_name: testSequence.procedure_definition_name  ,
    //       };
      
    //       setTsdHexColor(testSequence.hex_color );
    //       setSelectedProcedureDefinitions([reportExecutionOrder]); 
    //     }
    //   }, [testSequence]);
  
    const handleColorChange = (color: string) => {
      setTsdHexColor(color);
    };

                                       
      React.useEffect(() => {
        if (
          testSequence &&
          testSequence.report_execution_orders          &&
          testSequence.report_execution_orders          .length !== 0
        ) {
          const procedureDefinitions: ReportExecutionOrder[] =
            testSequence.report_execution_orders.map((procedureDefinition: any) => {
              const procedureExecutionOrder: ReportExecutionOrder = {
                execution_group_name: procedureDefinition.execution_group_name ,
                report_definition_id: procedureDefinition.report_definition_id  ,
                execution_group_number: procedureDefinition.execution_group_number ,
                product_definition_id: procedureDefinition.product_definition_id ,
                procedure_definition_name:procedureDefinition.report_definition_name,
                test_definition_id: tsdId || 0
              }
    
              return procedureExecutionOrder;
            });
    
          setTsdHexColor(testSequence.hex_color);
          setSelectedProcedureDefinitions(procedureDefinitions);
        }
      }, [testSequence]);

    
  
    // const addProcedureDefinitionToSelected = async (
    //   procedureDefinition: ProcedureExecutionOrder
    // ) => {
    //   try {
    //     await addProcedureDefinitionToTestSequence({
    //       testSequenceId: tsdId,
    //       procedureDefinitions: [procedureDefinition],
    //     });
  
    //     setSelectedProcedureDefinitions((prevState) =>
    //       addProcedureDefinitionToList(prevState, procedureDefinition)
    //     );
  
    //     toast.success("Added Procedure Definition to Test Sequence");
    //   } catch (e) {
    //     toast.error("Error adding Procedure Definition to Test Sequence");
    //   }
    // };
  
    // const removeProcedureDefinitionFromSelected = async (
    //   procedureDefinition: ProcedureExecutionOrder
    // ) => {
    //   try {
    //     await removeProceduresFromTestSequence({
    //       testSequenceId: tsdId,
    //       procedureDefinitions: [procedureDefinition],
    //     });
  
    //     await setSelectedProcedureDefinitions((prevState) =>
    //       removeProcedureDefinitionFromList(prevState, procedureDefinition)
    //     );
    //     toast.success("Deleted Procedure Definition");
    //   } catch (e) {
    //     toast.error("Error while deleting Procedure Definition");
    //   }
    // };
  
    // const editProcedureDefinitionInSelected = async (
    //   procedureDefinitionToEdit: ProcedureExecutionOrder,
    //   newProcedureDefinition: ProcedureExecutionOrder
    // ) => {
    //   try {
    //     await removeProceduresFromTestSequence({
    //       testSequenceId: tsdId,
    //       procedureDefinitions: [procedureDefinitionToEdit],
    //     });
  
    //     await addProcedureDefinitionToTestSequence({
    //       testSequenceId: tsdId,
    //       procedureDefinitions: [newProcedureDefinition],
    //     });
  
    //     await setSelectedProcedureDefinitions((prevState) =>
    //       addProcedureDefinitionToList(
    //         removeProcedureDefinitionFromList(
    //           prevState,
    //           procedureDefinitionToEdit
    //         ),
    //         newProcedureDefinition
    //       )
    //     );
    //     toast.success("Edited Procedure Definition");
    //   } catch (e) {
    //     toast.error("Error while editing Procedure Definition");
    //   }
    // };
  
    return (
      <React.Fragment>
     
  
        {testSequence && (
          <Container >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >  
              <Grid item xs={12}>
                <RSDForm
                  initialValues={{
                    name: testSequence.name+"_New",
                    shortName: testSequence.short_name+"_New",
                    description: testSequence.description,
                    version: testSequence.version,
                    disposition: testSequence.disposition,
                    // group: testSequence.group,
                    // unitTypeFamily: testSequence.unit_type_family,
                  }}
                  submitForm={async (values) => {

                    try {
                      await createTestSequence(
                        {
                          name: values.name,
                          short_name: values.shortName,
                          description: values.description,
                          disposition: values.disposition,
                          version: values.version,
                          // group: values.group,
                          // unit_type_family: values.unitTypeFamily,
                          hex_color: tsdHexColor,
                        },
                        {
                          onSuccess: async ({ id }) => {
                            toast.success(`Created report sequence ${id}`);
    
                            if (selectedProcedureDefinitions.length !== 0) {
                              try {
                                await addProcedureDefinitionsToTestSequence(
                                  {
                                    reportSequenceId: id,
                                    reportDefinitions:selectedProcedureDefinitions,
                                  },
                                  {
                                    onSuccess: () => {
                                      toast.success(
                                        "Added selected report definitions to report sequence"
                                      );
                                    },
                                  }
                                );
                              } catch (err) {
                                toast.error(
                                  "Failed to add report definition to report sequence"
                                );
                              }
                            }
    
                            history.push(`${id}`);
                          },
                        }
                      );
                    } catch (e) {
                      toast.error("Failed to create report Sequence Definition");
                    }



                    // const { shortName, unitTypeFamily, ...pickedValues } = values;
  
                    // const updatedTSD = {
                    //   ...pickedValues,
                    //   short_name: shortName,
                    //   unit_type_family: unitTypeFamily,
                    //   hex_color: tsdHexColor,
                    // };
  
                    // try {
                    //   const response = await updateTSD({ tsdId, updatedTSD });
                    //   console.log(response);
  
                    //   toast.success("Successfully updated TSD");
                    //   history.push(`${tsdId}`);
                    // } catch (e) {
                    //   toast.error("Error updating TSD");
                    // }
                  }}
                  selectedProcedureDefinitionsIsEmpty={
                    selectedProcedureDefinitions.length === 0
                  }
                >
                  <LSDBColorPicker
                    chipLabel="Test Sequence Definition Color"
                    onChange={handleColorChange}
                    initialHexColor={testSequence.hex_color}
                  />
                    <ReportDefinitionsPicker
                rsdProcedureDefinitions={selectedProcedureDefinitions}
                onAddItem={(newProcedureDefinition) => {
                  console.log("Adding new item to a new TSD");
                  console.log({ item: newProcedureDefinition });
                  addProcedureDefinitionToSelectedList(newProcedureDefinition);
                }}
                onEditItem={(
                  oldProcedureDefinition,
                  newProcedureDefinition
                ) => {
                  console.log("Editing existing item on a new TSD");
                  console.log({
                    oldPD: oldProcedureDefinition,
                    newPD: newProcedureDefinition,
                  });
                  editProcedureDefinitionInSelectedList(
                    oldProcedureDefinition,
                    newProcedureDefinition
                  );
                }}
                onDeleteItem={(procedureDefinitionToDelete) => {
                  console.log("Deleting item on a new TSD");
                  console.log({ item: procedureDefinitionToDelete });
                  removeProcedureDefinitionFromSelectedList(
                    procedureDefinitionToDelete
                  );
                }}
              />
                  {/* <ProcedureDefinitionsPicker
                    tsdProcedureDefinitions={selectedProcedureDefinitions}
                    onAddItem={async (newProcedureDefinition) => {
                      await addProcedureDefinitionToSelected(
                        newProcedureDefinition
                      );
                    }}
                    onEditItem={async (
                      oldProcedureDefinition,
                      newProcedureDefinition
                    ) => {
                      console.log(`Editing existing item in tsd ${tsdId}`);
                      console.log({
                        existingItem: oldProcedureDefinition,
                        newItem: newProcedureDefinition,
                      });
                      await editProcedureDefinitionInSelected(
                        oldProcedureDefinition,
                        newProcedureDefinition
                      );
                    }}
                    onDeleteItem={async (procedureDefinitionToDelete) => {
                      await removeProcedureDefinitionFromSelected(
                        procedureDefinitionToDelete
                      );
                    }}
                  /> */}
                </RSDForm>
              </Grid>
            </Grid>
          </Container>
        )}
      </React.Fragment>
    );
  };
  export default RSDTemplate;
  